import { render, staticRenderFns } from "./gradeConfig.vue?vue&type=template&id=b0ba5932&scoped=true"
import script from "./gradeConfig.vue?vue&type=script&lang=js"
export * from "./gradeConfig.vue?vue&type=script&lang=js"
import style0 from "./gradeConfig.vue?vue&type=style&index=0&id=b0ba5932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ba5932",
  null
  
)

export default component.exports